export type TextInput = {value: string, base64Encoded: boolean}

export type CypherState = {
    cleartext: TextInput,
    cyphertext: TextInput,
    padtext: TextInput & {base64Encoded: true},
    padGenerationLength: number,
}

export function getState(): CypherState {
    const cleartext = {
        value: (document.getElementById("cleartext") as HTMLTextAreaElement).value,
        base64Encoded: (document.getElementById("encodedCleartext") as HTMLInputElement).checked
    };

    const cyphertext = {
        value: (document.getElementById("cyphertext") as HTMLTextAreaElement).value,
        base64Encoded: (document.getElementById("encodedCyphertext") as HTMLInputElement).checked
    };

    const padtext = {
        value: (document.getElementById("pad") as HTMLTextAreaElement).value,
        base64Encoded: true,
    } as const;

    const padGenerationLength = (document.getElementById("generatePadLength") as HTMLInputElement).valueAsNumber;

    return {
        cleartext,
        cyphertext,
        padtext,
        padGenerationLength,
    }
}

export function setState(state: CypherState): void {
    (document.getElementById("cleartext") as HTMLTextAreaElement).value = state.cleartext.value;
    (document.getElementById("encodedCleartext") as HTMLInputElement).checked = state.cleartext.base64Encoded;

    (document.getElementById("cyphertext") as HTMLTextAreaElement).value = state.cyphertext.value;
    (document.getElementById("encodedCyphertext") as HTMLInputElement).checked = state.cyphertext.base64Encoded;

    (document.getElementById("pad") as HTMLTextAreaElement).value = state.padtext.value;

    (document.getElementById("generatePadLength") as HTMLInputElement).valueAsNumber = state.padGenerationLength;
}